module.exports = __webpack_public_path__ + "img/ip-2.32a73074.png";